module.exports = __webpack_public_path__ + "static/media/logo-bpom.ef9a0665.png";